import { render, staticRenderFns } from "./AddTopic.vue?vue&type=template&id=729ec647&"
import script from "./AddTopic.vue?vue&type=script&lang=js&"
export * from "./AddTopic.vue?vue&type=script&lang=js&"
import style0 from "./AddTopic.vue?vue&type=style&index=0&id=729ec647&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports